export default __webpack_public_path__ + "static/media/ribbon-present.a3b51234.png";